<template>
  <vs-row>
    <h2 style="margin: auto;">Acesso ao Sistema</h2>
    <h3 v-if="ra">* Acesso Aluno</h3>
    <vs-row vs-w="12">
      <vs-col vs-xs="12" class="mt">
        <vs-input
          v-model="user"
          label-placeholder="Login"
          @keyup.enter="focusPasswordInput"
        />
      </vs-col>
    </vs-row>
    <vs-row vs-w="12">
      <vs-col vs-xs="12" class="mt">
        <vs-input
          v-model="password"
          type="password"
          label-placeholder="Senha"
          ref="password"
          @keyup.enter="login"
        />
      </vs-col>
    </vs-row>
    <vs-row v-show="error" vs-w="12">
      <vs-col vs-xs="12">
        <vs-alert
          class="error-alert mt"
          color="danger"
          closable
          :active.sync="error"
          close-icon="close"
          >Falha ao tentar fazer login. {{ error }}</vs-alert
        >
      </vs-col>
    </vs-row>
    <vs-row vs-w="12">
      <vs-button class="w-100 mxt" @click="login"> Entrar </vs-button>
    </vs-row>
  </vs-row>
</template>

<script>
import LoginService from "../services/auth";
import { saveDataInStorage } from "../helpers/storage";
import { bus } from "../main";
import { getProfiles } from "../helpers/storage";
import { safeNext } from "../helpers";

var Tawk_API = Tawk_API || {};
(function () {
  var s1 = document.createElement("script");
  var s0 = document.getElementsByTagName("script")[0];
  s1.async = true;
  s1.src = "https://embed.tawk.to/5f21c4894f3c7f1c910d78fd/default";
  s1.charset = "UTF-8";
  s1.setAttribute("crossorigin", "*");
  s0.parentNode.insertBefore(s1, s0);
})();

export default {
  name: "Login",
  data: () => ({
    user: "",
    password: "",
    error: false,
    ra: null,
  }),
  created() {
    bus.$emit("clearSteps");
    if (this.$route.params.ra) {
      this.ra = this.$route.params.ra;
    }
  },
  methods: {
    async login() {
      const self = this;
      this.$vs.loading({
        color: "danger",
      });
      await new LoginService()
        .login({
          username: this.user,
          password: this.password,
        })
        .then((res) => {
          const dataLogin = res.data;
          if (this.ra) {
            new LoginService()
              .checkStudentLogin({
                username: this.user,
                ra: this.ra,
              })
              .then((result) => {
                if (result.data.RESULTADO == "1") {
                  dataLogin.profiles = ["AlunoPortal"];
                  dataLogin.RA = this.ra;
                  saveDataInStorage(dataLogin);
                  self.changeRules();
                  bus.$emit("login");
                  this.$router.push("/reenrollment");
                } else {
                  this.error = "Login inválido";
                  this.ra = null;
                }
              })
              .catch((error) => {
                const { response } = error;
                this.error =
                  response?.data?.error || "Tente novamente mais tarde.";
              });
          } else {
            saveDataInStorage(dataLogin);
            try{
              window.Tracker.setUser({codusuario: this.user})
            } catch (err) {
              void err;
            }
            self.changeRules();
            bus.$emit("login");
            this.$router.push(safeNext(this.$route.query.next) || "/mailing");
          }
          this.$vs.loading.close();
        })
        .catch((error) => {
          const { response } = error;
          this.error = response?.data?.error || "Tente novamente mais tarde.";
          this.$vs.loading.close();
        });
    },
    focusPasswordInput() {
      this.$refs.password.focusInput();
    },
    changeRules() {
      const profiles = getProfiles();
      this.$acl.change(profiles);
    },
  },
};
</script>

<style scoped>
.error-alert {
  margin: 16px 0;
  height: initial;
}

@media screen and (max-width: 380px) {
  h2 {
    font-size: 1.25em;
  }
}
</style>
